export default __webpack_public_path__ + "27ff5f47fd7a81c774875331b4da117b.png";